import '@skyscanner/backpack-web/bpk-stylesheets';
import 'react-app-polyfill/ie11'; // For IE 11 support

import { createElement } from 'react';
import ReactDOM from 'react-dom';

import App from './App';

ReactDOM.render(createElement(App), document.getElementById('root'));
